import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
  Paper,
  AccordionSummary,
  Accordion,
  AccordionDetails,
  IconButton,
  Button,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import CachedIcon from "@material-ui/icons/Cached";
import RefreshIcon from '@material-ui/icons/Refresh';
import clsx from "clsx";
import moment from "moment";
import ClearIcon from "@material-ui/icons/Clear";
import Divider from "@material-ui/core/Divider";

//files
import { useStyles } from "../deliverScheduleDetails/styles";
import { loadTableData } from "../../../../containers/actions/common/fileActions";
import RowsPerPage from "../../models/inputs/RowsPerPage";
import Filter from "./batchFilter/Filter";
import {
  fetchBatches,
  newbatchesTable,
  getAllDSBatchStatus,
  batchStatusSource,
  getBatchQAStatus,
} from "../../../../containers/actions/common/saslAction";
import { getFeaturesAccess } from "../../../../containers/actions/common/accessControl";
import DeliveryScheduleBatchTable from "../deliveryScheduleBatchTable";
import Block from "./QuickSummary/Block";
// import Search from '../../grnReceipts/Search';
import StatusFilter from "../deliverScheduleDetails/StatusFilter";
import usePrevious from "../../../helpers/previousProps";
import PaginationInput from "../../models/pagination/PaginationInput";
import featuresAndValidations from "../../models/featuresAccess/FeaturesAndValidations";
import {
  batchFilters,
  dsFilters,
} from "../../../../containers/actions/common/filtersAction";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import BackDrop from "../../models/BackDrop";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsNoneSharpIcon from "@material-ui/icons/NotificationsNoneSharp";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Search from "./batchFilter/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ResetBatchDialog from "./ResetBatchDialog";
import DocumentResubmissionDialog from "./DocumentResubmissionDialog";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import ExpandLessIcon from "@material-ui/icons/ExpandLess";

const DSBIndex = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const { params } = props.match;

  const { collabType, organizationName } = localStorage;
  const [expanded, setExpanded] = useState(false);
  const [selectedCMOList, setSelectedCMOList] = useState([]);
  const [selectedMFGPlantList, setSelectedMFGPlantList] = useState([]);
  const [mfgPlantList, setMFGPlantList] = useState([]);
  const [allMFGPlantList, setAllMFGPlantList] = useState([]);
  const [filteredMFGPlantList, setFilteredMFGPlantList] = useState([]);
  const [filteredCMOList, setFilteredCMOList] = useState([]);
  const [productSearch, setProductSearch] = useState("");
  const [searchQuery, searchQueryInput] = useState("");
  const [tempSearch, tempSearchQury] = useState("");
  const [status, selectStatus] = useState(["all"]);
  const [qaStatus, selectQAStatus] = useState("all");
  const [viewByStatus, setViewByStatus] = useState("all");
  const [quickStatus, setQuickStatus] = useState(["all"]);
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filter, setFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentStatusName, setCurrentStatusName] = useState("");
  let loading = true;

  const [coaReminder, setCoaReminder] = useState(true);
  const [currentReminder, setCurrentReminder] = useState(1);
  const [resetBatchDialogOpen, setResetBatchDialogOpen] = useState(false);
  const [documentResubmissionDialogOpen, setDocumentResubmissionDialogOpen] = useState(false);
  const [resetBatchData, setResetBatchData] = useState(null);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const [consumptionLoading, setConsumptionLoading] = useState(false);
  const [responseError, setResponseError] = useState(null);
  const [phase2ConfirmDialogOpen, setPhase2ConfirmDialogOpen] = useState(false);
  const [phase2ResetData, setPhase2ResetData] = useState(null);
  const [phase2Loading, setPhase2Loading] = useState(false);

  // Get CMO members from Redux - must be declared before useEffect hooks
  let cmoMemberWithId = useSelector((state) =>
    state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      ? state.pcmp.pharmaCo.purchaseOrder.cmoMemberWithId
      : []
  );

  const getBatches = useCallback(() => {
    let data = {
      statusID: status,
      vendorMosymphonyIDList: selectedCMOList.length > 0 ? selectedCMOList : [],
      searchByNumber: searchQuery,
      searchByProductCode: productSearch,
      BSDStartDate: startDate,
      BSDEndDate: endDate,
      pageSize: noRowsPerPage,
      pageNumber: currentPage,
      qaStatusID: String(qaStatus),
      aslNumberList: selectedMFGPlantList.length > 0 ? selectedMFGPlantList : [],
    };

    if (currentStatusName === "Delayed") {
      data.delayedBatches = true;
      data.statusID = ["all"];
    }

    if (currentStatusName === "Needs Review for Low Confidence Levels") {
      data.needReviewBatches = true;
    }

    if (currentStatusName === "Shipped Pending GR") {
      data.shipmentBatches = true;
    }

    dispatch(loadTableData());
    dispatch(fetchBatches(data));
  }, [
    dispatch,
    selectedCMOList,
    productSearch,
    startDate,
    endDate,
    status,
    searchQuery,
    noRowsPerPage,
    currentPage,
    qaStatus,
    selectedMFGPlantList,
  ]);

  // useEffect's
  useEffect(() => {
    getBatches();

    if (
      JSON.stringify(status) === JSON.stringify(["all"]) &&
      JSON.stringify(quickStatus) === JSON.stringify(["all"]) &&
      selectedCMOList.length === 0 &&
      productSearch === "" &&
      searchQuery === "" &&
      startDate === null &&
      selectedMFGPlantList.length === 0 &&
      endDate == null &&
      qaStatus === "all"
    ) {
      setFilter(false);
    } else {
      setFilter(true);
    }

    return () => {
      if (newbatchesTable) {
        newbatchesTable.cancel("leaving page!");
      }
    };
  }, [
    dispatch,
    collabType,
    selectedCMOList,
    productSearch,
    startDate,
    endDate,
    status,
    quickStatus,
    qaStatus,
    searchQuery,
    noRowsPerPage,
    currentPage,
    getBatches,
    organizationName,
  ]);

  let totalPages = useSelector(
    (state) => state.pcmp.common.sasl.fetchAllBatches.data?.totalPages
  );

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess?.data?.deliverySchedule
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.deliverySchedulesFeatures
  );

  const featuresAndValidations = useSelector(
    (state) => state.pcmp.common.reports.rmpmGrnFeatures?.data
  );
  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(
        getFeaturesAccess(screenAccess?.screenId, "deliverySchedulesFeatures")
      ); //10 is DS screen ID
    // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
  }, [dispatch, screenAccess, featuresAccess]);

  useEffect(() => {
    if (screenAccess?.screenAccess) {
      dispatch(getAllDSBatchStatus());
      dispatch(getBatchQAStatus());
    }
    return () => {
      if (batchStatusSource) {
        batchStatusSource.cancel("leaving page!");
      }
    };
  }, [dispatch, screenAccess]);

  // Initialize filtered lists when data is loaded
  useEffect(() => {
    // When all plants list is updated, initialize filtered list
    if (allMFGPlantList.length > 0 && filteredMFGPlantList.length === 0) {
      setFilteredMFGPlantList(allMFGPlantList);
      setMFGPlantList(allMFGPlantList);
    }
  }, [allMFGPlantList, filteredMFGPlantList.length]);

  useEffect(() => {
    // When CMO data is loaded, initialize filtered list
    if (cmoMemberWithId.length > 0 && filteredCMOList.length === 0) {
      setFilteredCMOList(cmoMemberWithId);
    }
  }, [cmoMemberWithId, filteredCMOList.length]);

  const batchFilterValue = useSelector((state) => state.pcmp.common.filters);

  const firstLoad = useRef(true);
  useEffect(() => {
    if (
      batchFilterValue?.batchFilters &&
      firstLoad.current === true &&
      location.state?.batchDashboard
    ) {
      firstLoad.current = false;
      setSelectedCMOList(
        Array.isArray(batchFilterValue.batchFilters.selectedCMOList)
          ? batchFilterValue.batchFilters.selectedCMOList
          : []
      );
      setProductSearch(batchFilterValue.batchFilters.productSearch);
      setStartDate(batchFilterValue.batchFilters.startDate);
      setEndDate(batchFilterValue.batchFilters.endDate);
      searchQueryInput(batchFilterValue.batchFilters.searchQuery);
      selectStatus(batchFilterValue.batchFilters.status);
      setRowsPerPage(batchFilterValue.batchFilters.noRowsPerPage);
      setCurrentPage(batchFilterValue.batchFilters.currentPage);
      tempSearchQury(batchFilterValue.batchFilters.tempSearch);
      setViewByStatus(batchFilterValue.batchFilters.viewByStatus);
      selectQAStatus(batchFilterValue.batchFilters.qaStatus);
      setQuickStatus(batchFilterValue.batchFilters.quickStatus);
      dispatch(dsFilters());
    }
  }, [dispatch, batchFilterValue, location.state]);

  useEffect(() => {
    dispatch(
      batchFilters({
        selectedCMOList: selectedCMOList,
        productSearch: productSearch,
        startDate: startDate,
        endDate: endDate,
        searchQuery: searchQuery,
        status: status,
        qaStatus: qaStatus,
        noRowsPerPage: noRowsPerPage,
        currentPage: currentPage,
        tempSearch: tempSearch,
        viewByStatus: viewByStatus,
        quickStatus: quickStatus,
      })
    );
  }, [
    dispatch,
    selectedCMOList,
    productSearch,
    startDate,
    endDate,
    searchQuery,
    status,
    qaStatus,
    noRowsPerPage,
    currentPage,
    tempSearch,
    viewByStatus,
    quickStatus,
  ]);

  // useEffect(() => {
  //   if (
  //     batchFilterValue?.batchFilters &&
  //     firstLoad.current === true &&
  //     batchFilterValue.batchFilters.productSearch === ''
  //   ) {
  //     dispatch(batchFilters({ productSearchValue: null }));
  //   }
  // }, [dispatch, batchFilterValue]);

  // useSelector's
  let filteredBatches = useSelector((state) => {
    if (
      state.pcmp.common.sasl.fetchAllBatches.data &&
      state.pcmp.common.sasl.fetchAllBatches.status === true
    ) {
      loading = false;
      return state.pcmp.common.sasl.fetchAllBatches.data
        .deliveryScheduleBatches;
    }
    if (
      state.pcmp.common.sasl.fetchAllBatches.data &&
      state.pcmp.common.sasl.fetchAllBatches.status === false
    ) {
      loading = false;
      return [];
    }
    return [];
  });

  let coaReminderNotification = filteredBatches.filter(
    (val) => val.sendReminderForCOAUpload === true
  );

  let statusArray = useSelector((state) => {
    if (state.pcmp.common.sasl?.allDSStatus) {
      return state.pcmp.common.sasl.allDSStatus;
    }
    return [];
  });

  let qaStatusArray = useSelector((state) => {
    if (state.pcmp.common.sasl.allQAStatus) {
      return state.pcmp.common.sasl.allQAStatus;
    } else {
      return [];
    }
  });

  const quickStatuses = useSelector((state) => {
    if (state.pcmp.common.sasl?.quickSummaryStatus) {
      return state.pcmp.common.sasl.quickSummaryStatus;
    }
    return [];
  });

  // ── Batched quickSummary counts ──────────────────────────────────────
  // One call returns counts for all tiles. Block renders '—' if a count
  // is missing (e.g. fetch error).
  const [tileCounts, setTileCounts] = useState({});
  const [tileLoading, setTileLoading] = useState(true);

  // Filter same as the Block.map filter below — must stay in sync.
  const visibleTiles = quickStatuses.filter((s) => {
    return (
      (s.statusID && s.statusID.length > 0) ||
      (s.firstStatusName && s.firstStatusName.trim() !== "")
    );
  });

  useEffect(() => {
    if (visibleTiles.length === 0) {
      setTileCounts({});
      setTileLoading(false);
      return;
    }
    let cancelled = false;
    setTileLoading(true);

    const tiles = visibleTiles.map((s, i) => {
      const tile = {
        tileId: i,
        statusID: Array.isArray(s.statusID) ? s.statusID : [],
      };
      const names = `${s.firstStatusName || ""} ${s.secondStatusName || ""}`;
      if (names.includes("Delayed")) tile.delayedCountRequired = true;
      if (names.includes("Needs Review for Low Confidence Levels")) tile.reviewCountRequired = true;
      if (names.includes("Shipped Pending GR")) tile.shipmentCountRequired = true;
      return tile;
    });

    const body = {
      tiles,
      vendorMosymphonyIDList: selectedCMOList && selectedCMOList.length > 0 ? selectedCMOList : [],
      aslNumberList: selectedMFGPlantList && selectedMFGPlantList.length > 0 ? selectedMFGPlantList : [],
      searchByProductCode: productSearch,
      BSDStartDate: startDate,
      BSDEndDate: endDate,
    };

    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/quickSummaryBatchCountsDirect`,
        body
      )
      .then((res) => {
        if (cancelled) return;
        setTileCounts(res?.data?.data?.counts || {});
        setTileLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        console.error("quickSummaryBatchCountsDirect failed:", err);
        setTileCounts({});
        setTileLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // Same deps as Block's internal useEffect (minus statusID/names which are part of tiles config)
    JSON.stringify(visibleTiles.map((s) => ({ id: s.statusID, n1: s.firstStatusName, n2: s.secondStatusName }))),
    JSON.stringify(selectedCMOList),
    JSON.stringify(selectedMFGPlantList),
    productSearch,
    startDate,
    endDate,
  ]);

  let updated = useSelector((state) => {
    return state.pcmp.common.sasl?.batchUpdated;
  });

  let previousUpdate = usePrevious(updated);

  useEffect(() => {
    if (updated && updated !== previousUpdate && updated.status) {
      // handleClean();
      getBatches();
    }
  }, [updated, previousUpdate, getBatches]);

  useEffect(() => {
    if (params.batchNo) {
      // let data = {
      //   statusID: status,
      //   vendorMosymphonyID: CMOMember,
      //   searchByNumber: params.batchNo.trim(),
      //   searchByProductCode: productSearch,
      //   BSDStartDate: null,
      //   BSDEndDate: null,
      //   pageSize: noRowsPerPage,
      //   pageNumber: currentPage,
      // };

      // dispatch(loadTableData());
      // dispatch(fetchBatches(data));
      setStartDate(null);
      setEndDate(null);
      tempSearchQury(params.batchNo);
      searchQueryInput(params.batchNo.trim());
      setFilter(true);
    }
  }, [params.batchNo]);

  // function for CMO Filter
  const handleSelectCMO = (event) => {
    const value = event.target.value;
    setSelectedCMOList(value);
    setFilter(true);
    setCurrentPage(1);
    loading = true;

    // Filter MFG Plants based on selected CMOs
    if (value.length === 0) {
      // No CMOs selected, show all plants
      setFilteredMFGPlantList(allMFGPlantList);
      setMFGPlantList(allMFGPlantList);
    } else {
      // Filter plants that belong to selected CMOs
      const filtered = allMFGPlantList.filter(plant =>
        value.includes(plant.vendorMosymphonyID)
      );
      setFilteredMFGPlantList(filtered);
      setMFGPlantList(filtered);

      // Update selected plants to only include those from selected CMOs
      const validPlantIds = filtered.map(p => p.aslNumber);
      setSelectedMFGPlantList(prev =>
        prev.filter(plantId => validPlantIds.includes(plantId))
      );
    }
  };

  // function for MFG Plant Filter
  const handleSelectMFGPlant = (event) => {
    const value = event.target.value;
    if (value.includes("All")) {
      // Toggle: if all selected, deselect all; otherwise select all
      if (selectedMFGPlantList.length === mfgPlantList.length) {
        setSelectedMFGPlantList([]);
      } else {
        setSelectedMFGPlantList(mfgPlantList.map(plant => plant.aslNumber));
      }
    } else {
      setSelectedMFGPlantList(value);
    }
    setFilter(true);
    setCurrentPage(1);

    // Filter CMOs based on selected plants
    const selectedPlants = value.includes("All")
      ? (selectedMFGPlantList.length === mfgPlantList.length ? [] : mfgPlantList.map(p => p.aslNumber))
      : value;

    if (selectedPlants.length === 0) {
      // No plants selected, show all CMOs
      setFilteredCMOList(cmoMemberWithId);
      if (selectedMFGPlantList.length > 0) {
        setSelectedCMOList([])
        setFilteredMFGPlantList(mfgPlantList)
      }
    } else {
      // Get unique CMO IDs from selected plants
      const plantObjects = allMFGPlantList.filter(p => selectedPlants.includes(p.aslNumber));
      const cmoIds = [...new Set(plantObjects.map(p => p.vendorMosymphonyID))];

      // Filter CMOs that have the selected plants
      const filtered = cmoMemberWithId.filter(cmo =>
        cmoIds.includes(cmo.organization_id)
      );
      setSelectedCMOList(filtered.map(c => c.organization_id));
      setFilteredCMOList(filtered);

      // // Update selected CMOs to only include those that have selected plants
      // const validCMOIds = filtered.map(c => c.organization_id);
      // setSelectedCMOList(prev =>
      //   prev.filter(cmoId => validCMOIds.includes(cmoId))
      // );
    }
  };

  // const selectedCMO = () => {
  //   if (CMOMember === 'all') {
  //     return CMOMember;
  //   } else {
  //     let cmo = cmoMemberWithId.filter(
  //       (member) => member.organization_id === parseInt(CMOMember)
  //     );
  //     return cmo[0].organization_name;
  //   }
  // };

  // functions for Product Search Filter
  const handleProductSearchQuery = (value) => {
    if (value === "" || value === null) {
      setProductSearch("");
      setCurrentPage(1);
    } else {
      setProductSearch(value.fgMaterialCode);
      setFilter(true);
      setCurrentPage(1);
    }
  };

  // function for Date Filter
  const handleDateChange = (name, date) => {
    let d = new Date(date);

    if (name === "startDate") {
      d = moment(date)
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("milliseconds", 0)
        .format("Y-MM-DDTHH:mm:ss.SSS");

      setStartDate(d);
    }
    if (name === "endDate") {
      d = moment(date)
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 59)
        .set("milliseconds", 999)
        .format("Y-MM-DDTHH:mm:ss.SSS");

      setEndDate(d);
      setCurrentPage(1);
    }
    setFilter(true);
  };

  // functions for Search By Batch/ (PO/SA)/ GRN Number
  const handleSearchQuery = (event) => {
    let { value } = event.target;
    if (value === "" || value === null) {
      tempSearchQury(value);
      searchQueryInput("");
      setFilter(false);
    } else {
      tempSearchQury(value);
      setFilter(true);
    }
  };

  const handleClearSearch = (event) => {
    event.preventDefault();
    tempSearchQury("");
    searchQueryInput("");
  };

  const submitSearch = (event) => {
    event.preventDefault();
    setCurrentPage(1);
    searchQueryInput(tempSearch.trim());
  };

  // functions for the Status Filter
  // handleViewStatus
  const handleViewStatus = (event) => {
    setQuickStatus(["all"]);
    let status = String(event.target.value);
    setViewByStatus(status);
    selectStatus([status]);
    setFilter(true);
    setCurrentPage(1);
  };

  // handle Quick Summary Status
  const handleQuickStatus = (value, statusName) => {
    setViewByStatus("all");
    // integer array to string array
    let status = value.map(String);
    setQuickStatus(status);
    selectStatus(status);
    setFilter(true);
    setCurrentPage(1);
    setCurrentStatusName(statusName);
  };

  const handleCleanQuickSummary = () => {
    setQuickStatus(["all"]);
    selectStatus(["all"]);
    setRowsPerPage(5);
    setCurrentPage(1);
    setCurrentStatusName("");
  };

  // Clean function to clean filters
  const handleClean = () => {
    setSelectedCMOList([]);
    setSelectedMFGPlantList([]);
    // Reset filtered lists to show all options
    setFilteredCMOList(cmoMemberWithId);
    setFilteredMFGPlantList(allMFGPlantList);
    setProductSearch("");
    setStartDate(null);
    setEndDate(null);
    searchQueryInput("");
    selectStatus(["all"]);
    setRowsPerPage(5);
    setCurrentPage(1);
    tempSearchQury("");
    setFilter(false);
    setViewByStatus("all");
    setQuickStatus(["all"]);
    selectQAStatus("all");
    setCurrentStatusName("");
    setSelectedMFGPlantList([])
  };

  //debounce
  const debounce = (callback, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  const debouncedLog = debounce((data) => {
    setCurrentPage(data);
  }, 600);

  const getCurrentPageNumber = (data) => {
    debouncedLog(data);
  };

  // functions for pagination
  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleSelectQAStatus = (event) => {
    selectQAStatus(event.target.value);
  };

  const qualityApprovalFlowFlag = useSelector((state) => {
    return state.pcmp.common.reports.rmpmGrnFeatures?.data?.features?.qualityApprovalEnabled;
  });

  let showPagination = filteredBatches
    ? filteredBatches.length > 0
      ? true
      : false
    : false;

  const handleReminderClose = () => {
    setCoaReminder(false);
  };

  const handleBack = () => {
    if (currentReminder !== 1) {
      setCurrentReminder(currentReminder - 1);
    }
  };

  const handleNext = () => {
    if (currentReminder !== coaReminderNotification.length) {
      setCurrentReminder(currentReminder + 1);
    }
  };

  // Phase 2 Reset — handles "Update changes" click in confirmation dialog
  const handlePhase2UpdateChanges = async () => {
    setPhase2Loading(true);
    setResponseError(null);
    try {
      const requestArray = phase2ResetData.associatedBatches.map((batch) => ({
        schrockenDeliveryScheduleBatchID: batch.schrockenDeliveryScheduleBatchID,
        poNumber: batch.scheduleAgreementNumber,
        batchNumber: batch.vendorBatchNumber,
        vendorMosymphonyID: batch.vendorMosymphonyID,
        creationDate: batch.creationDate,
        vendorNumber: batch.vendorNumber,
        vendorPlant: batch.vendorPlant,
        isStorageOrAddressOrKeyChange: phase2ResetData.reasonForReset === 'Need to change storage location, delivery address and/or confirmation control key',
      }));

      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGBatchForWorkflowReset`,
        requestArray
      );

      setPhase2ConfirmDialogOpen(false);
      if (response.data?.status) {
        setResetBatchData(phase2ResetData);
        setResponseError(null);
        setSuccessDialogOpen(true);
      } else {
        setResponseError(response.data?.message || 'Failed to reset batch. Please try again.');
        setResetBatchData(phase2ResetData);
        setSuccessDialogOpen(true);
      }
    } catch (error) {
      console.error('Error calling updateFGBatchForWorkflowReset API (Phase 2):', error);
      setPhase2ConfirmDialogOpen(false);
      setResponseError(error.response?.data?.message || 'An error occurred. Please try again.');
      setResetBatchData(phase2ResetData);
      setSuccessDialogOpen(true);
    } finally {
      setPhase2Loading(false);
    }
  };

  return (
    <React.Fragment>
      <BackDrop />
      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs={12} md={10}>
          <Filter
            selectedCMOList={selectedCMOList}
            CMOMemberId={selectedCMOList}
            cmoFilter={collabType === "Pharma Co" ? true : false}
            handleSelectCMO={handleSelectCMO}
            filterByCMOName={false}
            mfgPlantFilter={collabType === "Pharma Co" ? true : false}
            handleSelectMFGPlant={handleSelectMFGPlant}
            selectedMFGPlantList={selectedMFGPlantList}
            setMFGPlantList={setMFGPlantList}
            setAllMFGPlantList={setAllMFGPlantList}
            filteredMFGPlantList={filteredMFGPlantList}
            filteredCMOList={filteredCMOList}
            productSearch={productSearch}
            handleProductSearchQuery={handleProductSearchQuery}
            startDate={startDate}
            endDate={endDate}
            handleDateChange={handleDateChange}
          />
        </Grid>
        <Grid item style={{ alignItems: "end", display: "flex", gap: "1rem" }}>
          {featuresAccess?.resetBatch && (
            <Button
              variant="contained"
              style={{
                backgroundColor: "#e36e39",
                color: "#FFFFFF",
                borderRadius: "20px",
                padding: "6px 16px",
                textTransform: "none",
                fontWeight: 500,
                transition: "all 0.3s ease-in-out",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "black";
                e.currentTarget.style.border = "1px solid black";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#e36e39";
                e.currentTarget.style.border = "none";
              }}
              onClick={() => {
                setResetBatchDialogOpen(true);
              }}
            >
              Reset Batch
            </Button>
          )}
          {filter && (
            <Typography
              variant="caption"
              style={{ justifyContent: "end", fontSize: 12 }}
              className={clsx(
                classes.dpFlx,
                classes.algnCntr,
                classes.pointer,
                classes.onHvrUndrline
              )}
              onClick={handleClean}
            >
              Clear All Filters
              <ClearIcon color="primary" style={{ fontSize: 15 }} />
            </Typography>
          )}
        </Grid>
      </Grid>

      <Divider style={{ marginTop: "1rem" }} />
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        style={{ boxShadow: "none", margin: 0 }}
      >
        <AccordionSummary
          className={classes.accordionSummary}
        // expandIcon={<ExpandMoreIcon />}
        >
          <Grid container style={{ justifyContent: "space-between" }}>
            <Grid item>
              <div style={{ display: "flex", alignItems: "center" }}>
                <IconButton
                  style={{ marginRight: "8px" }}
                  onClick={() => setExpanded(!expanded)}
                  size="small"
                >
                  {expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                </IconButton>
                <Typography
                  variant="body2"
                  style={{ paddingBottom: "inherit", fontWeight: 600 }}
                >
                  Quick Summary:
                </Typography>
              </div>
            </Grid>
            {status === quickStatus && (
              <Grid item>
                <Typography
                  variant="caption"
                  color="primary"
                  onClick={handleCleanQuickSummary}
                  className={clsx(
                    classes.dpFlx,
                    classes.algnCntr,
                    classes.pointer,
                    classes.onHvrUndrline
                  )}
                >
                  Clear Quick Summary
                  <ClearIcon color="primary" style={{ fontSize: 15 }} />
                </Typography>
              </Grid>
            )}
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid
            container
            spacing={1}
            wrap="nowrap"
            style={{
              overflowX: "auto",
              display: "flex",
              justifyContent: "space-between",
              gap: "0rem",
            }}
          >
            {quickStatuses
              .filter((statuses) => {
                return (
                  (statuses.statusID && statuses.statusID.length > 0) ||
                  (statuses.firstStatusName && statuses.firstStatusName.trim() !== "")
                );
              })
              .map((statuses, i) => (
                <Block
                  key={i}
                  data={statuses}
                  handleQuickStatus={(value) =>
                    handleQuickStatus(value, statuses.firstStatusName)
                  }
                  status={status}
                  batchedCount={tileCounts[i]}
                  batchedLoading={tileLoading}
                />
              ))}
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Divider />

      <Grid
        container
        alignItems="center"
        className={classes.pdTp}
        style={{ paddingBottom: "2rem", paddingTop: "2rem" }}
      >
        <Grid item xs={12} sm={8} md={4}>
          <Search
            searchQuery={tempSearch}
            handleSearchQuery={handleSearchQuery}
            handleClearSearch={handleClearSearch}
            submitSearch={submitSearch}
            placeholder={"Search using Batch, PO/SA, GRN Number, Brand"}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          {localStorage.collabType === "CMO" &&
            featuresAndValidations?.features?.qualityApprovalEnabled &&
            featuresAccess?.updateFGBatch &&
            coaReminderNotification.length > 0 &&
            coaReminder && (
              <Grid item>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  style={{
                    backgroundColor: "#c2e7ff",
                    padding: "1rem",
                    borderRadius: "14px",
                  }}
                >
                  <Paper
                    style={{
                      color: "white",
                      backgroundColor: "#F00",
                      borderRadius: "20px",
                    }}
                  >
                    <NotificationsNoneSharpIcon />
                  </Paper>
                  <>
                    <ArrowBackIosIcon
                      page={currentReminder}
                      titleAccess="Previous"
                      onClick={handleBack}
                      color={currentReminder === 1 ? "disabled" : "action"}
                      style={{
                        cursor: "pointer",
                        height: "16px",
                        paddingLeft: "5px",
                        color: "black",
                      }}
                    />
                    <Typography variant="body1" style={{ width: "auto" }}>
                      {currentReminder} of {coaReminderNotification.length}
                    </Typography>
                    <ArrowForwardIosIcon
                      size="small"
                      titleAccess="Next"
                      page={currentReminder}
                      onClick={handleNext}
                      color={
                        currentReminder === coaReminderNotification.length
                          ? "disabled"
                          : "action"
                      }
                      style={{
                        cursor: "pointer",
                        height: "16px",
                        paddingRight: "5px",
                        color: "black",
                      }}
                    />
                  </>
                  <Typography style={{ width: "30rem" }}>
                    {`You have received a reminder from ${coaReminderNotification[currentReminder - 1]
                      ?.brandOwnerName
                      } to upload CoA for Batch ${coaReminderNotification[currentReminder - 1]
                        ?.vendorBatchNumber
                      }`}
                  </Typography>
                  <CloseIcon
                    fontSize="small"
                    onClick={handleReminderClose}
                    style={{
                      cursor: "pointer",
                      color: "#F00",
                      paddingLeft: "5px",
                    }}
                  />
                </Grid>
              </Grid>
            )}
          {/* <Grid
            container
            className={clsx(
              classes.dpFlx,
              classes.flxEndSmFlxStrt,
              classes.pdTponLr
            )}
          >
            <Typography variant='caption' className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                'HH:mm:ss; DD MMMM, YYYY'
              )}`}
            </Typography>

            <Typography
              variant='caption'
              color='primary'
              onClick={getBatches}
              className={clsx(
                classes.dpFlx,
                classes.algnCntr,
                classes.pointer,
                classes.onHvrUndrline
              )}
            >
              Refresh
              <CachedIcon color='primary' style={{ fontSize: 15 }} />
            </Typography>
          </Grid> */}
        </Grid>

        <Grid
          container
          alignItems="flex-end"
          justifyContent="space-between"
          className={classes.pdTp}
        >
          <Grid item xs={4} sm={3}>
            <Typography variant="body2" className={classes.hgText}>
              View by:
            </Typography>
            <StatusFilter
              status={viewByStatus}
              handleSelectStatus={handleViewStatus}
              statusArray={statusArray}
            />
          </Grid>
          {qualityApprovalFlowFlag && (
            <Grid item xs={4} sm={3} style={{ paddingLeft: "10px" }}>
              <Typography variant="body2" className={classes.hgText}>
                View by QA Status:
              </Typography>
              <FormControl style={{ minWidth: 120 }} fullWidth>
                <Select
                  labelId="qa-status-filter"
                  id="qa-status-filter-id"
                  value={qaStatus}
                  onChange={handleSelectQAStatus}
                  variant="outlined"
                  classes={{
                    outlined: classes.outlined,
                  }}
                // MenuProps={{
                //   PaperProps: {
                //     style: {
                //       height: qaStatusArray.length > 1 ? '27%' : '8%',
                //       overflowY:
                //         qaStatusArray.length > 1 ? 'scroll' : 'hidden',
                //     },
                //   },
                // }}
                >
                  <MenuItem value="all">All</MenuItem>
                  {qaStatusArray.map((dsStatus, index) => {
                    return (
                      <MenuItem key={index} value={dsStatus.statusID}>
                        {dsStatus.statusDisplayName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              {/* <StatusFilter
                status={qaStatus}
                handleSelectStatus={handleSelectQAStatus}
                statusArray={qaStatusArray}
              /> */}
            </Grid>
          )}

          <Grid
            item
            xs={4}
            sm={6}
            className={clsx(classes.searchFld, classes.flxEd)}
            style={{ flexDirection: "column", alignItems: "end" }}
          >
            <div style={{ display: "flex" }}>
              <Typography
                variant="caption"
                className={`${clsx(classes.padR20)} last-synced-text`}
              >
                {`Last synced @ ${moment(new Date()).format(
                  "HH:mm:ss; DD MMMM YYYY"
                )}`}
              </Typography>

              <Typography
                variant="caption"
                color="primary"
                onClick={getBatches}
                className={`${clsx(
                  classes.dpFlx,
                  classes.algnCntr,
                  classes.pointer,
                  classes.onHvrUndrline
                )} refresh-button`}
              >
                Refresh
                {/* <CachedIcon className="refresh-button svg" color="primary" style={{ fontSize: 15 }} /> */}
                <RefreshIcon
                  className="refresh-button svg"
                  color="primary"
                  style={{ fontSize: 15 }}
                />
              </Typography>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                paddingTop: "1rem",
              }}
            >
              <RowsPerPage value={noRowsPerPage} onChange={handleSetRows} />
            </div>
          </Grid>
        </Grid>
      </Grid>

      <DeliveryScheduleBatchTable
        batchData={filteredBatches}
        loading={loading}
        batchDashboard
        featuresAccess={featuresAccess}
        onRefreshData={getBatches}
      />

      {showPagination === true && (
        <PaginationInput
          totalPages={totalPages}
          handlePageChange={getCurrentPageNumber}
          page={currentPage}
        />
      )}

      <ResetBatchDialog
        open={resetBatchDialogOpen}
        onClose={() => {
          setResetBatchDialogOpen(false);
          setResponseError(null);
        }}
        isLoading={consumptionLoading}
        onContinue={async (data) => {
          // Phase 2 reset reasons — open confirmation dialog
          if (data.isPhase2Reset) {
            setResetBatchDialogOpen(false);
            setPhase2ResetData(data);
            setPhase2ConfirmDialogOpen(true);
            return;
          }
          // Check if "Consumption rejected by mistake" is selected
          if (data.reasonForReset === 'Consumption rejected by mistake') {
            // Directly call updateFGBatchForWorkflowReset API with consumption payload
            setConsumptionLoading(true);
            setResponseError(null);
            setResetBatchData(data); // Store data for success/error dialog

            try {
              const payload = [{
                poNumber: data.poNumber,
                batchNumber: data.batchNumber,
                schrockenDeliveryScheduleBatchID: data.schrockenDeliveryScheduleBatchID,
                consumptionResetRequested: true,
                vendorMosymphonyID: data.vendorMosymphonyID,
              }];

              const response = await axios.post(
                `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/updateFGBatchForWorkflowReset`,
                payload
              );

              // Close ResetBatchDialog first
              setResetBatchDialogOpen(false);

              if (response.data?.status) {
                // Success - show success dialog
                setResponseError(null);
                setSuccessDialogOpen(true);
              } else {
                // Error - show error dialog
                setResponseError(response.data?.message || 'Failed to reset consumption. Please try again.');
                setSuccessDialogOpen(true); // Open dialog to show error
              }
            } catch (error) {
              console.error('Error calling updateFGBatchForWorkflowReset API:', error);
              // Close ResetBatchDialog first
              setResetBatchDialogOpen(false);
              // Error - show error dialog
              setResponseError(error.response?.data?.message || 'An error occurred. Please try again.');
              setSuccessDialogOpen(true); // Open dialog to show error
            } finally {
              setConsumptionLoading(false);
            }
          } else {
            // For document resubmission options, close ResetBatchDialog and open the second dialog
            setResetBatchDialogOpen(false);
            setResetBatchData(data);
            setDocumentResubmissionDialogOpen(true);
          }
        }}
      />

      <DocumentResubmissionDialog
        open={documentResubmissionDialogOpen}
        onClose={() => setDocumentResubmissionDialogOpen(false)}
        batchData={resetBatchData}
        reasonForReset={resetBatchData?.reasonForReset}
        onSuccess={() => {
          setDocumentResubmissionDialogOpen(false);
          setSuccessDialogOpen(true);
        }}
      />

      {/* Phase 2 Confirmation Dialog */}
      <Dialog
        open={phase2ConfirmDialogOpen}
        // onClose={() => setPhase2ConfirmDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ style: { borderRadius: '8px', maxWidth: '700px' } }}
      >
        <div style={{ padding: '16px 24px' }}>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ width: '100%' }}>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                <Typography
                  style={{ display: 'flex', alignItems: 'center', cursor: phase2Loading ? 'default' : 'pointer', fontWeight: 500 }}
                  onClick={() => {
                    if (!phase2Loading)
                      setPhase2ConfirmDialogOpen(false)
                  }}
                >
                  Cancel <CloseIcon style={{ fontSize: '24px', marginLeft: '4px', color: '#FF0000' }} />
                </Typography>
              </div>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Typography style={{ fontWeight: 600, fontSize: '1.5rem', color: '#000', textAlign: "center" }}>
                  {phase2ResetData?.reasonForReset}
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <DialogContent style={{ padding: '16px 24px' }}>
          {/* Blue ribbon with batch details */}
          <div style={{
            backgroundColor: '#EBF2FA',
            borderRadius: '4px',
            padding: '12px 16px',
            marginBottom: '24px',
          }}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: 600, fontSize: '0.8rem', color: '#333' }}>PO Number</Typography>
                <Typography style={{ fontSize: '0.85rem', color: '#000' }}>{phase2ResetData?.poNumber}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: 600, fontSize: '0.8rem', color: '#333' }}>Batch Number</Typography>
                <Typography style={{ fontSize: '0.85rem', color: '#000' }}>
                  {phase2ResetData?.associatedBatches?.map(b => b.vendorBatchNumber).join(', ')}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: 600, fontSize: '0.8rem', color: '#333' }}>CMO</Typography>
                <Typography style={{ fontSize: '0.85rem', color: '#000' }}>{phase2ResetData?.cmo}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: 600, fontSize: '0.8rem', color: '#333' }}>Batch Status</Typography>
                <Typography style={{ fontSize: '0.85rem', color: '#000' }}>{phase2ResetData?.batchStatus}</Typography>
              </Grid>
            </Grid>
          </div>
          {/* Confirmation message */}
          <Typography style={{ textAlign: 'center', fontSize: '1rem', color: '#333', marginBottom: '24px' }}>
            Please confirm if the {phase2ResetData?.reasonForReset?.replace('Need to change ', '')} for PO {phase2ResetData?.poNumber} is changed in SAP. Click on the button below to initiate Batch Reset.
          </Typography>
          {/* Update Changes button */}
          <div style={{ display: 'flex', justifyContent: 'center', paddingBottom: '16px' }}>
            <Button
              onClick={handlePhase2UpdateChanges}
              disabled={phase2Loading}
              style={{
                backgroundColor: phase2Loading ? '#CCCCCC' : '#e36e39',
                color: '#FFFFFF',
                borderRadius: '20px',
                padding: '8px 32px',
                textTransform: 'none',
                fontWeight: 500,
              }}
            >
              {phase2Loading ? 'Processing...' : 'Update changes'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Success/Error Dialog */}
      {successDialogOpen &&

        <Dialog
          open={successDialogOpen}
          // onClose={() => {
          //   setSuccessDialogOpen(false);
          //   setResponseError(null);
          // }}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: 12,
            },
          }}
        >
          <DialogContent style={{ textAlign: 'center', padding: '32px 48px' }}>
            {responseError ? (
              // Error state
              <>
                <ErrorIcon style={{ fontSize: 60, color: '#f44336', marginBottom: '16px' }} />
                <Typography style={{ fontWeight: 600, fontSize: '1.125rem', marginBottom: '16px', color: '#f44336' }}>
                  Error
                </Typography>
                <Typography style={{ color: '#f44336', marginBottom: '24px', fontSize: '0.875rem' }}>
                  {responseError}
                </Typography>
              </>
            ) : (
              // Success state
              <>
                <CheckCircleIcon style={{ fontSize: 60, color: '#2e7d32', marginBottom: '16px' }} />
                <Typography style={{ fontWeight: 600, fontSize: '1.125rem', marginBottom: '24px' }}>
                  {resetBatchData?.reasonForReset === 'Consumption rejected by mistake' || resetBatchData?.isPhase2Reset
                    ? 'Batch Reset Successfully'
                    : 'Document Resubmission Request sent to CMO Successfully'}
                </Typography>
              </>
            )}
            <Button
              onClick={() => {
                setSuccessDialogOpen(false);
                setResponseError(null);
                if (!responseError) getBatches();
              }}
              style={{
                backgroundColor: '#e36e39',
                color: '#FFFFFF',
                borderRadius: 20,
                padding: '6px 32px',
                textTransform: 'none',
                fontWeight: 500,
                transition: 'all 0.3s ease-in-out',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#c44d15';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(227, 110, 57, 0.4)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#e36e39';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(227, 110, 57, 0.3)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(227, 110, 57, 0.4)';
              }}
            >
              OK
            </Button>
          </DialogContent>
        </Dialog>
      }

      {/* Loading Backdrop for Consumption/Phase 2 Reset */}
      <BackDrop open={consumptionLoading || phase2Loading} />
    </React.Fragment>
  );
};

export default featuresAndValidations(DSBIndex);
